import CommonButton from "../../components/commonButton";
import { routes } from "../../routes/pageRoutes";
import { PlusIcon, Upload04Icon } from "../../assets/icons";
import { FilterBtn } from "../../components/commonButton/btns";
import { TableSearch } from "../../components/form/Fields";

const NpaAddImpExprtBtn = ({
  filterValues,
  navigate,
  setFilterValues,
  setFilterModal,
  importBtnHandler,
  setCurrentPage,
  handleExportNpaProperties,
  totalProperties,
  cardStatus,
  canCreate,
  canExport
}) => {
  const hasValue = (v) =>
    Array.isArray(v) ? v.length > 0
      : typeof v === "string" ? v.trim() !== ""
        : v != null && v !== false; // safety for future booleans/numbers

  // Check if any value except 'search' is non-empty
  const isFilterActive = Object?.entries(filterValues)
    .filter(([key]) => key !== "search") // Exclude the 'search' key
    .some(([, value]) => hasValue(value)); // Check if any value is non-empty

  return (
    <>
      <div className="p-4 d-flex align-items-center justify-content-between flex-wrap gap-3">
        <div className="d-flex  align-items-center gap-4">


          <TableSearch value={filterValues?.search}
            placeholder="City, state, possession, borrower's name"
            onChange={(e) => {
              setFilterValues((val) => ({
                ...val,
                search: e.target.value,
              }));
              setCurrentPage(1)
            }} />
          <FilterBtn onClick={() => setFilterModal(true)} active={isFilterActive} />

        </div>
        <div className="d-flex gap-2">
          {canCreate && (
            <CommonButton
              icon={<Upload04Icon strokeWidth="2.0" style={{ transform: "rotate(180deg)" }} />}
              variant="secondary"
              onClick={importBtnHandler}
              title="Import"
              type="button"
            />
          )}
          {
            canExport && totalProperties?.length > 0 && (
              <CommonButton
                icon={<Upload04Icon strokeWidth="2.0" />}
                variant="secondary"
                title="Export"
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  handleExportNpaProperties(cardStatus);
                }}
              />
            )
          }

          {canCreate && (
            <CommonButton
              icon={<PlusIcon />}
              title="Add Property"
              onClick={(e) => {
                e.stopPropagation();
                navigate(routes.addNpaProperties);
              }}
            />
          )}
        </div>
      </div>

    </>
  );
};

export default NpaAddImpExprtBtn;
